import { useAppSelector } from '../../state';
import { selectLinkTokenPayload } from '../../state/slices/slice-link-params';
import { tokenHasPlatform } from '../../utils';
var usePartnerBasedFallbackRoute = function () {
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    if (tokenHasPlatform(linkTokenPayload)) {
        return '/link-api/login';
    }
    return '/search/search';
};
export default usePartnerBasedFallbackRoute;
